module.exports = __webpack_public_path__ + "img/list_icon5.e5debc99.png";